import _ from 'lodash';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { searchTripsRequest, searchTripsSuccess } from '../../slices/trip';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* tripsSearchWorker() {
  try {
    const { tripsSearch } = yield select((store) => store.trip);
    const customBookingFieldParts = tripsSearch.searchObj.customBookingFields
      ? _.flatMap(tripsSearch.searchObj.customBookingFields, (customField) =>
          _.map(customField.value, (valList) => `customField[${customField.key}]=${valList}`),
        )
      : [];

    const requestObj = {
      ...tripsSearch.searchObj,
      pageSize: !tripsSearch.searchObj.doViewAll ? 4 : null,
      doViewAll: null,
      bookingStatus: _.map(tripsSearch.searchObj.bookingStatus, (u) => u.value),
      areFiltersEmpty: null,
    };
    delete requestObj.customBookingFields;
    delete requestObj.selectedUsers;

    let url = `trips/getAll?${queryString.stringify(requestObj, { skipNull: true })}`;
    if (customBookingFieldParts.length) {
      url += `&${customBookingFieldParts.join('&')}`;
    }

    const config = {
      method: 'post',
      url,
      data: {
        selectedUsers: _.map(tripsSearch.searchObj.selectedUsers, (u) => u.value),
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    const response = yield call(axios, config);
    if (response.data) {
      yield put(searchTripsSuccess({ ...response.data }));
    } else throw new Error();
  } catch (error) {
    yield put(searchTripsSuccess({}));
  }
}

function* tripsSearchWatcher() {
  yield takeLatest(searchTripsRequest.toString(), tripsSearchWorker);
}

export default tripsSearchWatcher;
